import { Flex, Button, Grid, Text, ListItem, Box } from '@chakra-ui/react';
import { useState } from 'react';
import { withSiteExtensionData } from '../lib/hoc';
import { useTranslation } from '../lib/hooks.context';
import { mapNewsTeaserProps } from '../lib/resolvers';
import { NewsTeaser } from '../types';
import SiteSearch from './SiteSearch';
import Teaser from './Teaser';
import TeaserSplit from './TeaserSplit';
import OrderedList from './OrderedList';
import { mhyDateSort } from '../lib/utils';

interface Props {
  news: NewsTeaser[];
  isLoading?: boolean;
}

const defaultLimit = 13;
const step = defaultLimit;

// State always holds people and filtered is either a subset of that or false
interface State {
  limit: number;
}

const NewsList = ({ news, isLoading }: Props) => {
  const [{ limit }, setShownEvents] = useState<State>({
    limit: defaultLimit,
  });
  const t = useTranslation();

  const sortedNews = news
    ?.slice()
    .sort(({ date: a }, { date: b }) => mhyDateSort(a, b));

  const showMore = () => {
    setShownEvents((s) => ({
      ...s,
      limit: s.limit + step,
    }));
  };

  return (
    <Box as="section">
      <Flex
        as="header"
        mb={[8, 10, 14]}
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gridGap="4"
        sx={{ '> *': { width: 'auto' } }}
      >
        <SiteSearch isLoading={isLoading} />
      </Flex>
      <Grid
        templateColumns={[
          '1fr',
          'repeat(auto-fit, minmax(250px, 1fr))',
          'repeat(auto-fit, minmax(325px, 1fr))',
        ]}
        gap="10"
        mb="10"
        sx={{ '> *:first-of-type': { gridColumn: '1 / -1' } }}
        as={OrderedList}
      >
        {sortedNews.slice(0, limit).map((post, i) => {
          const TeaserComponent = i ? Teaser : TeaserSplit;
          return (
            <TeaserComponent
              key={`${post.id || post.title}-${post.site}`}
              as={ListItem}
              {...mapNewsTeaserProps(post, t, !i)}
            />
          );
        })}
        {!news?.length ? <Text>{t('news_no_items')}</Text> : null}
      </Grid>
      {news?.length > limit ? (
        <Flex as="footer" justifyContent="center">
          <Button onClick={showMore} variant="solidGreen" size="large">
            {t('load_more')}
          </Button>
        </Flex>
      ) : null}
    </Box>
  );
};

export default withSiteExtensionData<Pick<Props, 'news'>>(NewsList, {
  param: 'sites',
  dataKey: 'news',
});
